var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"field",attrs:{"prefix":_vm.currency,"value":_vm.amount},on:{"input":_vm.handleInput}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }